import React from 'react';
import { FadeIn } from './FadeIn';
export function ClosingContrast() {
  return <section className="py-20 sm:py-32 px-4 bg-carbon-900 border-t border-carbon-800 blueprint-grid" data-id="element-33">
      <div className="max-w-5xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-4xl sm:text-5xl font-display text-center text-white mb-6 uppercase tracking-wide" data-id="element-36">
            Una última cosa antes de que decidas.
          </h2>
          <p className="text-xl text-center text-carbon-300 font-sans mb-16" data-id="element-37">
            La próxima semana vas a estar en alguno de estos dos lugares.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-38">
          <FadeIn delay={0.1} data-id="element-39">
            <div className="bg-carbon-950 border border-carbon-800 rounded-3xl p-8 sm:p-12 h-full" data-id="element-40">
              <div className="font-mono text-carbon-500 text-sm uppercase tracking-widest mb-6 border-b border-carbon-800 pb-2" data-id="element-41">
                El primer lugar
              </div>
              <p className="text-carbon-300 font-sans leading-relaxed text-lg" data-id="element-42">
                Llegás al lunes sin saber exactamente qué trabajar. Improvisás
                la sesión. Entrenás fuerte pero sin progresión real. Sin datos.
                Sin evidencia. Y la semana siguiente es exactamente igual. Con
                la misma frustración. Con la misma sensación de que algo tiene
                que cambiar pero sin saber cómo.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-43">
            <div className="bg-carbon-900 border border-electric/30 rounded-3xl p-8 sm:p-12 h-full relative overflow-hidden" data-id="element-44">
              <div className="absolute top-0 left-0 w-full h-1 bg-electric" data-id="element-45" />
              <div className="font-mono text-electric text-sm uppercase tracking-widest mb-6 border-b border-electric/30 pb-2" data-id="element-46">
                El segundo lugar
              </div>
              <p className="text-white font-sans leading-relaxed text-lg font-medium" data-id="element-47">
                Llegás al lunes con la semana planificada, la sesión
                estructurada y tu diario listo para registrar. Entrenás con
                propósito. Progresás y lo ves. Sabés exactamente por qué. Y en
                12 meses sos un atleta notablemente más completo, más fuerte y
                más resistente.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-48">
          <div className="text-center" data-id="element-49">
            <p className="text-xl sm:text-2xl text-carbon-300 font-sans mb-6" data-id="element-50">
              La diferencia entre esos dos lugares no es el talento. No es la
              genética. No es el tiempo disponible.
            </p>
            <p className="text-5xl sm:text-7xl font-display text-white uppercase tracking-wide leading-[0.9]" data-id="element-51">
              Es el sistema. <br data-id="element-52" />
              <span className="text-electric" data-id="element-53">Y el sistema está acá.</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}